import {useTranslation} from 'react-i18next'
import {ConfirmDialog} from '@/components/confirm-dialog'

type Person = {user_id: string; name: string; last_name: string}
type Mutation = {isPending: boolean; mutate: (userId: string, opts: {onSettled: () => void}) => void}

export function RosterActivationConfirms({
  tKey,
  deactivateTarget,
  reactivateTarget,
  onCloseDeactivate,
  onCloseReactivate,
  deactivate,
  reactivate,
}: {
  tKey: string
  deactivateTarget: Person | null
  reactivateTarget: Person | null
  onCloseDeactivate: () => void
  onCloseReactivate: () => void
  deactivate: Mutation
  reactivate: Mutation
}) {
  const {t} = useTranslation()
  return (
    <>
      <ConfirmDialog
        open={!!deactivateTarget}
        onOpenChange={(open) => !open && onCloseDeactivate()}
        title={t(`${tKey}.deactivate.title`)}
        description={t(`${tKey}.deactivate.description`, {
          name: deactivateTarget ? `${deactivateTarget.name} ${deactivateTarget.last_name}` : '',
        })}
        confirmLabel={t(`${tKey}.deactivate.confirm`)}
        cancelLabel={t('common.cancel')}
        pending={deactivate.isPending}
        onConfirm={() => {
          if (!deactivateTarget) return
          deactivate.mutate(deactivateTarget.user_id, {onSettled: onCloseDeactivate})
        }}
      />
      <ConfirmDialog
        open={!!reactivateTarget}
        onOpenChange={(open) => !open && onCloseReactivate()}
        title={t(`${tKey}.reactivate.title`)}
        description={t(`${tKey}.reactivate.description`, {
          name: reactivateTarget ? `${reactivateTarget.name} ${reactivateTarget.last_name}` : '',
        })}
        confirmLabel={t(`${tKey}.reactivate.confirm`)}
        cancelLabel={t('common.cancel')}
        pending={reactivate.isPending}
        onConfirm={() => {
          if (!reactivateTarget) return
          reactivate.mutate(reactivateTarget.user_id, {onSettled: onCloseReactivate})
        }}
      />
    </>
  )
}
